export enum ConditionId {
  HOUSING_PERMISSION = 'HOUSING_PERMISSION',
  SEARCH_PERIOD = 'SEARCH_PERIOD',
  RESIDENTS = 'RESIDENTS'
}
